import { useEffect, useState } from 'react'

/*
  Generic Thank You page at /thank-you.
  Displayed after successful form submissions (contact, feedback, etc.).
  No Figma design — styled to align with the MIG style guide:
    - alfarn-2 700 for headings
    - Poppins Light/Regular for body
    - MIG colour tokens (#000000 primary, #F9F9FA bg)
    - Consistent spacing with other MIG pages (px-24, py-80)
    - BACK button matching other detail pages

  Styling lives in src/styles/pages/thank-you.css.
*/

export default function ThankYou() {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 100)
    return () => clearTimeout(timer)
  }, [])

  return (
    <section className="mig-page-section">
      <div className="mig-page-title-row" data-visible={visible}>
        <h1 className="mig-thankyou-page-title">Thank you</h1>
      </div>

      <div className="mig-thankyou-content">
        <p className="mig-thankyou-message">Your enquiry has been received.</p>

        <div className="mig-divider-line" />

        <div className="mig-page-back-row">
          <a href="/" className="mig-thankyou-back-button">BACK</a>
          <div className="mig-divider-line" />
        </div>
      </div>
    </section>
  )
}
